export default {
  // 测试地址
  // baseURL: "https://dev-api.leyanbot.com/wsk/talent"
  // 线上地址
  baseURL: "https://rct.cntalents.com.cn/talent/"
};



// WEBPACK FOOTER //
// ./src/http/env.js